<script setup>
import { VideoStore } from '@/front/stores/video_store.js'
import { PlayerStore } from '@/front/stores/player_store.js'
import { ClickStore } from '@/front/stores/click_store.js'
const clickStore = ClickStore()
const playerStore = PlayerStore()
const videoStore = VideoStore()

import { PlaybackStore } from '@/front/stores/playback_store.js'
const playbackStore = PlaybackStore()
import Button from 'primevue/button';
import { PlayIcon } from 'hugeicons-vue'
import LoopingPlayer from '@/front/components/LoopingPlayer.vue'
import { cdnImageUrl } from '@/front/composables/ImageComposer.js'
const { t } = useI18n({});
// Have to calcualte aspect ratio to pin layer to actual video

const getIntroLayerStyle = computed(() => {
  // let styles = {
  //   left: playerStore.layerDimensions.left,
  //   top: playerStore.layerDimensions.top,
  //   width: playerStore.layerDimensions.width,
  //   height: playerStore.layerDimensions.height,
  // }
  let styles = {
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  }
  if (!videoStore.video.id) {
    return styles
  }
  if (videoStore.video.design.thumbnail && !videoStore.video.design.use_moving_preview) {
    styles.backgroundImage = `url(${cdnImageUrl(videoStore.video.design.thumbnail)})`
    styles.backgroundSize = 'contain'
    styles.backgroundPosition = 'center'
    styles.backgroundRepeat = 'no-repeat'
  }
  return styles
})


const startVideo = () => {
  // log.info(5,"startVideo")

  if (playbackStore.existingPlay) {
    log.info(5,"startVideo existingPlay", playbackStore.existingPlay)
    clickStore.showResumeDialog()
  } else {
    // log.info(5,"startVideo newPlay")
    playerStore.togglePlayer()
  }
}

</script>

<template>
  <div v-if="videoStore.video.id" id="intro-layer" @click.stop="startVideo" class="absolute top-0 left-0 w-full h-full fill-height" :style="getIntroLayerStyle"> 
    <div class="flex flex-col items-center justify-center h-full cursor-pointer relative" :class="{ 'opacity-100': playerStore.ready }">
      <LoopingPlayer v-if="videoStore.video.design.use_moving_preview" class="absolute top-0 left-0 w-full h-full z-0 bg-black " />
      
      <img v-show="videoStore.video.design.play_button_image" :src="cdnImageUrl(videoStore.video.design.play_button_image)" class="w-1/5 min-w-24 z-10 opacity-0 transition-opacity duration-200" :class="{ 'opacity-100': playerStore.ready, 'pulse_v1': videoStore.video.design.pulse_play_button }">
      <!-- <PlayIcon v-else class="text-white w-24 h-24 z-10 pulse_v1" /> -->
      <img v-show="!videoStore.video.design.play_button_image" src="https://resource-cdn.mindstamp.com/assets/play-filled.png" class="w-[15%] min-w-12 z-10 max-w-48 p-[2%] pl-[2.5%] opacity-0 transition-opacity duration-200 !bg-[var(--user-theme-color)] rounded-full" :class="{ 'opacity-100': playerStore.ready, 'pulse_v1': videoStore.video.design.pulse_play_button }">

    </div>
  </div>
  <div id="intro-layer-overlay" @click.stop="startVideo" class="absolute top-0 left-0 w-full h-full fill-height bg-black/10 cursor-pointer" :style="getIntroLayerStyle"/> 
  <div v-if="videoStore.video.showTitle" class="absolute top-2 left-2 max-w-[80%]"> 
    <div class="text-white font-bold text-sm @sm/player:text-base @md/player:text-xl @lg/player:text-2xl @2xl/player:text-4xl bg-black/70 rounded-lg p-2 @xl/player:p-4 "> {{ videoStore.video.title }} </div>
  </div>

  <div v-if="videoStore.video.showMessage && videoStore.video.message" class="absolute bottom-0 left-0 p-2 @xl/player:p-4"> 
    <div class="text-white font-bold text-sm @sm/player:text-base @md/player:text-xl @lg/player:text-2xl @xl/player:text-3xl"> 
      <div class="flex items-center justify-center">
        <img v-if="videoStore.video.design.avatar" :src="cdnImageUrl(videoStore.video.design.avatar)" class="w-8 h-8 @sm/player:w-12 @sm/player:h-12 @xl/player:w-16 @xl/player:h-16  h-auto rounded-full mr-2">
        {{ videoStore.video.message }} 

      </div>
    </div>
  </div>

  <div v-if="videoStore.video.show_branding && videoStore.video.design.icon" class="absolute top-0 right-0 p-4"> 
    <img :src="cdnImageUrl(videoStore.video.design.icon)" class="w-12 @sm/player:w-16 @md/player:w-20 @lg/player:w-32 @xl/player:w-48 h-auto">
  </div>
</template>

<style>
</style>
